import { render } from "./ChamadoAuth.vue?vue&type=template&id=233b4988&scoped=true"
import script from "./ChamadoAuth.vue?vue&type=script&lang=js"
export * from "./ChamadoAuth.vue?vue&type=script&lang=js"

import "./ChamadoAuth.vue?vue&type=style&index=0&id=233b4988&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-233b4988"]])

export default __exports__